import React from 'react'
import localization from '../localization/localization'
import CardComponent from '../cardComponent/CardComponent'
import AboutUsComponent from '../aboutUs/AboutUsComponent'
import CarouselComponent from './Carousel'
import CountDown from './CountDown'
import { NavLink } from "react-router-dom"
import './Intro.css'

const Intro = (props) => {
  const carouselImages = [
    process.env.PUBLIC_URL + '/media/Carousel2.jpg',
    process.env.PUBLIC_URL + '/media/alamakipyorailya_teijolla.jpg',
    process.env.PUBLIC_URL + '/media/Carousel3.jpg',
    process.env.PUBLIC_URL + '/media/Carousel4.jpg',
  ];

  return (
    <div className="index-body">
      <div className="parallax-body">
        <CarouselComponent carouselImages={carouselImages} />
        <h1>
          <span>{localization.home.info.mtb}</span>
          
          <br/>
          <br/>
         <span>{localization.home.sun}</span>
          <br/>
          <span><NavLink to="/events">{localization.home.info.shop}</NavLink> </span>
          <br/>
          <CountDown />
        </h1>
        <div className="levitating-arrow-body">
          <p>
            <i className="levitating-arrow"></i>
          </p>
        </div>
      </div>
      <div className="parallax-scroll">
        <CardComponent />
        <AboutUsComponent />
      </div>
    </div>
  );
};

export default Intro;